import React, { Component, useState } from "react";
import { render } from "react-dom";
import ConcListD from "./ConcListDesktop";
import ConcList from "./ConcListMobile";
import { useMediaQuery } from 'react-responsive'


export default function AdminHomeResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <ConcListD/>}
        {isMobileDevice && <ConcListD/>}  
      </div>
    )
}

